module.exports = __webpack_public_path__ + "static/media/bomb.76727829.JPG";